export { default } from "./PhoneVerificationTextField";

export type { PhoneVerificationTextFieldProps } from "./PhoneVerificationTextField";
